<div class="tw-flex tw-items-center tw-justify-center">
  @if (flagSymbolId(); as flag) {
    <svg class="tw-w-8 tw-h-10 tw-rounded-full">
      <use [attr.xlink:href]="'images/sprite.svg#' + flag"></use>
    </svg>
  }
</div>
